import React from "react";
import { Link } from "@quintype/components";
import { shape, string, array } from "prop-types";

import "./story-tag.m.css";

const Tag = ({ tag }) => (
  <Link href={"/topic/" + tag.slug} styleName="story-tag">
    {tag.name}
  </Link>
);

Tag.propTypes = {
  tag: shape({
    slug: string,
    name: string
  })
};

const StoryTag = ({ tags = [] }) => {
  return (
    <ul styleName="tag-wrapper">
      {tags.map((tag, index) => {
        return (
          <li styleName="tag-element" key={index}>
            <Tag tag={tag} />
          </li>
        );
      })}
    </ul>
  );
};

StoryTag.propTypes = {
  tags: array
};

export default StoryTag;
